import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ebo-textarea',
  templateUrl: './ebo-textarea.component.html',
  styleUrls: ['./ebo-textarea.component.scss']
})
export class EboTextareaComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder = '';
  @Input() required = false;
  @Input() hint = '';
  @Input() control: FormControl;
  @Input() rows = 0;
  /** Controls the CSS resize behaviour. Defaults to 'none' (no resize handle). */
  @Input() resize: 'none' | 'vertical' | 'horizontal' | 'both' = 'none';

  isFocused = false;

  ngOnInit(): void {
    // Initialize value from control if provided
    if (this.control && this.control.value) {
      // Value is already set in the control
    }
  }

  onInputChange(event: any): void {
    if (this.control) {
      this.control.setValue(event.target.value);
      this.control.markAsTouched();
    }
  }

  onFocus(): void {
    this.isFocused = true;
  }

  onBlur(): void {
    this.isFocused = false;
    if (this.control) {
      this.control.markAsTouched();
    }
  }

  get hasError(): boolean {
    return this.control && this.control.invalid && this.control.touched;
  }

  get errorMessage(): string {
    if (!this.control || !this.hasError) {
      return '';
    }

    const errors = this.control.errors;
    if (errors?.required) {
      return 'This field is required';
    }
    if (errors?.minlength) {
      return `Minimum length is ${errors.minlength.requiredLength}`;
    }
    if (errors?.maxlength) {
      return `Maximum length is ${errors.maxlength.requiredLength}`;
    }
    return 'Invalid value';
  }
}
